module.exports = __webpack_public_path__ + "img/delivery01.1535d85d.png";